import { REMOTE_PERMISSIONS } from '@backrs_ui/common-ui';

import { useHasPermission } from '@backrs_ui/grow-ui/src/hooks/useHasPermission';

/**
 * The one predicate behind every institution-admin surface. A second reading of
 * the same permission would let one surface outlive a withdrawal of the others.
 */
export const useIsInstitutionAdmin = (): boolean =>
  useHasPermission(REMOTE_PERMISSIONS.MANAGE_INSTITUTION_MEMBERS);
